import React, { useState, useEffect, useRef } from "react";
import Loader from "../../shared/loader/loader";
import DeleteModal from "../../shared/common/deleteModal";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import Constant from "../../../utils/constant";
import { useNavigate, Link } from "react-router";
import { connect } from "react-redux";
import Select from "react-select";
import {
  getGradeAll,
  getStateAll,
  getSubject,
  getSubjectTypes,
} from "../../../api/subject.service";
import { ISubjectPage } from "../../../model/interface/subject";
import {
  postSellableProduct,
  updateSellableProduct,
  getSellableProductById,
  getSubjectsSellableProduct,
  deleteSellableProductSubject,
  getCannedTestsSellableProduct,
  deleteSellableProductCannedTest,
  updateSellableProductCannedTest,
  getItemBanksSellableProduct,
  deleteSellableProductItemBank,
} from "../../../api/pricing.services";
import {
  addSellableProductToExisting,
  updateSellableProductSubject,
  getSellableProductTypes,
  getItemBanks,
} from "../../../api/sellableProduct.service";
import {
  DeleteIcon,
  EditIcon,
  CheckIcon,
  CancelIcon,
} from "../../../assets/icons/index";
import {
  ISelectElement,
  IReactSelect,
} from "../../../model/interface/keyValuePair";
import MultiSelect from "../../shared/common/multiSelect";
import { toast } from "react-toastify";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";
import { SellableProductAssociationTable } from "./SellableProductAssociationTable";

const ManageSellableProducts: React.FC<any> = (props: any) => {
  const defaultDropdownValues = {
    value: 0,
    label: "",
  };
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];
  const defaultSubjectType = { value: "1", label: "PL" };
  const defaultProductType: ISelectElement = { value: "1", label: "Subjects" };
  const sellableProductId = useNumericParam("id");
  const subjectFilterMounted = useRef(false);
  const [manageNotification, setManageNotification] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [sellableproductName, setsellableproductName] = useState<string>("");
  const [editSellableProduct, seteditSellableProduct] = useState<any>();
  const [selectedProductType, setSelectedProductType] =
    useState<ISelectElement>(
      sellableProductId ? { value: "", label: "" } : defaultProductType
    );
  const [productTypes, setProductTypes] = useState<ISelectElement[]>([]);
  const [cannedTestIds, setCannedTestIds] = useState<number[]>([]);
  const [cannedTestInput, setCannedTestInput] = useState<string>("");
  const [cannedTestError, setCannedTestError] = useState<string>("");
  const [selectedItemBank, setSelectedItemBank] = useState<ISelectElement[]>(
    []
  );
  const [itemBanks, setItemBanks] = useState<ISelectElement[]>([]);
  const navigate = useNavigate();
  const [grade, setGrade] = useState<any>([]);
  const [state, setState] = useState<any>([]);
  const [subjects, setSubjects] = useState<any>([]);
  const [selectSubject, setSelectSubject] = useState<Array<IReactSelect>>([]);
  const [selectState, setSelectState] = useState<IReactSelect>(
    defaultDropdownValues
  );
  const [selectGrade, setSelectGrade] = useState<IReactSelect>(
    defaultDropdownValues
  );
  const [selectGradeLevel, setSelectGradeLevel] = useState<ISelectElement>({
    value: "",
    label: "",
  });
  const [sellableproductSubjects, setSellableproductSubjects] = useState<any>(
    []
  );
  const [DeleteSellableProductSubject, setDeleteSellableProductSubject] =
    useState<number>(0);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [sellableProductCannedTests, setSellableProductCannedTests] = useState<
    Array<{ cannedTestId: number; name: string; isHandScorable?: boolean }>
  >([]);
  const [deleteCannedTestId, setDeleteCannedTestId] = useState<number>(0);
  const [showDeleteCannedTestModal, setShowDeleteCannedTestModal] =
    useState<boolean>(false);
  const [sellableProductItemBanks, setSellableProductItemBanks] = useState<
    Array<{ itemBankId: number; name: string }>
  >([]);
  const [deleteItemBankId, setDeleteItemBankId] = useState<number>(0);
  const [showDeleteItemBankModal, setShowDeleteItemBankModal] =
    useState<boolean>(false);
  const [isSPNameEdit, setIsSPNameEdit] = useState<boolean>(false);
  const [isApproved, setIsApproved] = useState<boolean>(true);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [selectedSubjectType, setSelectedSubjectType] =
    useState<ISelectElement>(defaultSubjectType);
  const [subjectTypes, setSubjectTypes] = useState<ISelectElement[]>([]);
  const [updateSellableproductSubjects, setUpdateSellableproductSubjects] =
    useState<any>([]);
  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setState(newStateData);
    setLoading(false);
  };

  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrade(newGradeData);
  };
  const getSubjectTypeData = () => {
    getSubjectTypes().then((types) => {
      const subjecTypes = types.data.map((_g) => {
        return {
          label: _g.name,
          value: parseInt(_g.id),
        };
      });

      setSubjectTypes(subjecTypes);
    });
  };
  function filterSubjects(resetObj?, onFilter?) {
    const subjectData: ISubjectPage = {
      name: "",
      stateId: selectState?.value || 0,
      gradeId: selectGrade?.value || 0,
      gradeLevel:
        selectedSubjectType?.value != "2" ? selectGradeLevel.value : "",
      orderbyColumn: "name",
      sortDir: "asc",
      isActive: true,
      isApproved: true,
      subjectId: 0,
      subjectTypeId: selectedSubjectType?.value
        ? parseInt(selectedSubjectType?.value)
        : 0,
      isStandardFilter: true,
    };

    getSubject(resetObj ? resetObj : subjectData).then((response: any) => {
      let newSubjectData = [];
      if (response.data.data.length > 0) {
        newSubjectData = response.data.data.map((eachSubjectData) => {
          return {
            value: eachSubjectData.subjectId || 0,
            label: `${eachSubjectData.name}`,
            contentAreaName: eachSubjectData.contentAreaName,
          };
        });
      }
      setSubjects(newSubjectData);
    });
  }

  const getProductTypeData = () => {
    getSellableProductTypes().then((response) => {
      const types = response.data.map((t: any) => ({
        value: String(t.id),
        label: t.name,
      }));
      setProductTypes(types);
    });
  };

  const getItemBankData = () => {
    getItemBanks().then((response) => {
      const banks = response.data.map((b: any) => ({
        value: String(b.itemBankId),
        label: b.name,
      }));
      setItemBanks(banks);
    });
  };

  useEffect(() => {
    getSubjectTypeData();
    getProductTypeData();
    getItemBankData();
    if (sellableProductId && sellableProductId > 0) {
      getSellableProductById(sellableProductId).then((response) => {
        seteditSellableProduct(response.data);
        setIsApproved(response?.data?.isApproved);
        setIsActive(response?.data?.isActive);
        if (response?.data?.sellableProductTypeId) {
          const typeId = String(response.data.sellableProductTypeId);
          setSelectedProductType({ value: typeId, label: "" });
        }
        if (response?.data?.cannedTestIds?.length > 0) {
          const ids: number[] = response.data.cannedTestIds;
          setCannedTestIds(ids);
          setCannedTestInput(ids.join(", "));
        }
        if (response?.data?.itemBankIds?.length > 0) {
          setSelectedItemBank(
            response.data.itemBankIds.map((id: number) => ({
              value: String(id),
              label: "",
            }))
          );
        }
      });
    }
  }, [sellableProductId]);

  useEffect(() => {
    if (!subjectFilterMounted.current) {
      subjectFilterMounted.current = true;
      return;
    }
    const typeId = parseInt(selectedProductType.value);
    if (typeId === 1 || typeId === 2) {
      filterSubjects();
    }
  }, [selectGrade, selectState, selectGradeLevel, selectedSubjectType]);

  useEffect(() => {
    if (editSellableProduct != null) {
      setsellableproductName(editSellableProduct.name);
    }
  }, [editSellableProduct]);

  const sellableProductSubject = () => {
    async function sellableData() {
      setLoading(true);
      const response = getSubjectsSellableProduct(sellableProductId);
      let data = (await response).data;
      if (data && data.length) {
        data = data.map((ds) => {
          const obj: any = {};
          obj.value = ds.subjectId;
          obj.contentAreaName = ds.contentAreaName;
          obj.contentAreaId = ds.contentAreaId;
          obj.name = ds.name;
          obj.isPrimary = ds.isPrimary;

          return obj;
        });
      }
      setSellableproductSubjects(data);
      setLoading(false);
    }
    sellableData();
  };

  const loadSellableProductCannedTests = () => {
    if (!sellableProductId) return;
    setLoading(true);
    getCannedTestsSellableProduct(sellableProductId)
      .then((r) => {
        setSellableProductCannedTests(r.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadSellableProductItemBanks = () => {
    if (!sellableProductId) return;
    setLoading(true);
    getItemBanksSellableProduct(sellableProductId)
      .then((r) => {
        setSellableProductItemBanks(r.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    sellableProductSubject();
    loadSellableProductCannedTests();
    loadSellableProductItemBanks();
    getGradeData();
    getStateData();
  }, [sellableProductId]);

  const handleCannedTestChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    setCannedTestInput(raw);
    if (!raw.trim()) {
      setCannedTestIds([]);
      setCannedTestError("");
      return;
    }
    const parts = raw
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s !== "");
    const parsed = parts.map((s) => parseInt(s, 10));
    if (parsed.some((n) => isNaN(n))) {
      setCannedTestError("All Canned Test IDs must be valid numbers");
      setCannedTestIds([]);
    } else {
      setCannedTestError("");
      setCannedTestIds(parsed);
    }
  };

  const onUpdateClick = (type) => {
    setManageNotification(true);
    if (!sellableproductName) return;

    const typeId = parseInt(selectedProductType.value);
    if (typeId === 3 && (cannedTestIds.length === 0 || !!cannedTestError))
      return;
    if (typeId === 4 && selectedItemBank.length === 0) return;

    setLoading(true);
    if (type === "add") {
      const sellableSubjects: any = selectSubject;
      postSellableProduct({
        name: sellableproductName,
        isActive: true,
        isApproved: isApproved,
        sellableProductTypeId: typeId,
        subjectIds:
          typeId === 1 || typeId === 2
            ? sellableSubjects?.map((ds) => ds.value).toString()
            : "",
        cannedTestIds: typeId === 3 ? cannedTestIds : null,
        itemBankIds:
          typeId === 4 && selectedItemBank.length > 0
            ? selectedItemBank.map((b) => parseInt(b.value))
            : null,
        userId: props.profile?.userId,
      }).then((r) => {
        setLoading(false);
        toast.success("Sellable product added successfully");
        setTimeout(() => {
          navigate(
            Constant.MANAGESELLABLEPRODUCT.replace(":id", r.data.toString())
          );
        }, 1500);
      });
    } else if (type === "update") {
      const editsellableArray = {
        name: sellableproductName,
        isActive: isActive,
        isApproved: isApproved,
        sellableProductId: sellableProductId,
        sellableProductTypeId: typeId,
        cannedTestIds: typeId === 3 ? cannedTestIds : null,
        itemBankIds:
          typeId === 4 && selectedItemBank.length > 0
            ? selectedItemBank.map((b) => parseInt(b.value))
            : null,
        userId: props.profile?.userId,
      };

      updateSellableProduct(editsellableArray).then(() => {
        const afterUpdate = () => {
          setLoading(false);
          handleReset();
          sellableProductSubject();
          loadSellableProductCannedTests();
          loadSellableProductItemBanks();
          if (sellableProductId) {
            getSellableProductById(sellableProductId).then((response) => {
              if (response?.data?.cannedTestIds?.length > 0) {
                const ids: number[] = response.data.cannedTestIds;
                setCannedTestIds(ids);
                setCannedTestInput(ids.join(", "));
              }
              if (response?.data?.itemBankIds?.length > 0) {
                setSelectedItemBank(
                  response.data.itemBankIds.map((id: number) => ({
                    value: String(id),
                    label: "",
                  }))
                );
              }
            });
          }
          toast.success("Sellable product updated successfully");
          if (sellableProductId) {
            navigate(
              Constant.MANAGESELLABLEPRODUCT.replace(
                ":id",
                sellableProductId.toString()
              )
            );
          }
        };
        if (typeId === 1 || typeId === 2) {
          addSellableProductToExisting({
            productId: editSellableProduct?.sellableProductId,
            subjectIds: selectSubject?.map((ds) => ds.value).toString(),
          }).then(afterUpdate);
        } else {
          afterUpdate();
        }
      });
    }
  };

  const updateMultiDropdownValues = (updateObj, type) => {
    if (type === "state") {
      setSelectState(updateObj);
    }

    if (type === "grade") {
      setSelectGrade(updateObj);
    }

    if (type === "gradeLevel") {
      setSelectGradeLevel(updateObj);
    }
    if (type === "subjectType") {
      setSelectedSubjectType(updateObj);
    }

    if (type === "subjects") {
      setSelectSubject(updateObj);
      if (sellableproductSubjects.length > 0) {
        let subjectsToAdd: any = [];
        subjectsToAdd = [...sellableproductSubjects];
        updateObj.map((newObj) => {
          if (!subjectsToAdd.map((ds) => ds.value).includes(newObj.value)) {
            subjectsToAdd.push({
              value: newObj.value,
              name: newObj.label,
              contentAreaName: newObj.contentAreaName,
              contentAreaId: newObj.contentAreaId,
            });
          }
        });
        setUpdateSellableproductSubjects(subjectsToAdd);
      } else {
        setUpdateSellableproductSubjects([
          {
            value: updateObj.value,
            name: updateObj.label,
            contentAreaName: updateObj.contentAreaName,
          },
        ]);
      }
    }
  };

  const onDeleteClick = (subjectId) => {
    setShowDeleteModal(true);
    setDeleteSellableProductSubject(subjectId);
  };

  const deleteRecordHandler = async () => {
    setLoading(true);
    deleteSellableProductSubject(
      DeleteSellableProductSubject,
      editSellableProduct?.sellableProductId
    ).then(() => {
      setLoading(false);
      handleReset();
      sellableProductSubject();
      toast.success("Sellable product subject deleted successfully");

      setTimeout(() => {
        navigate(Constant.SELLABLEPRODUCT);
      }, 1500);
    });
    setShowDeleteModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const onDeleteCannedTestClick = (cannedTestId: number) => {
    setDeleteCannedTestId(cannedTestId);
    setShowDeleteCannedTestModal(true);
  };

  const deleteCannedTestRecordHandler = async () => {
    setLoading(true);
    deleteSellableProductCannedTest(deleteCannedTestId, sellableProductId).then(
      () => {
        setShowDeleteCannedTestModal(false);
        loadSellableProductCannedTests();
        if (sellableProductId) {
          getSellableProductById(sellableProductId).then((response) => {
            const ids: number[] = response?.data?.cannedTestIds ?? [];
            setCannedTestIds(ids);
            setCannedTestInput(ids.join(", "));
            setLoading(false);
          });
        } else {
          setLoading(false);
        }
        toast.success("Canned test removed from sellable product");
      }
    );
  };

  const closeDeleteCannedTestModal = () => {
    setShowDeleteCannedTestModal(false);
  };

  const onToggleHandScorable = (cannedTestId: number, checked: boolean) => {
    if (!sellableProductId) return;
    setLoading(true);
    updateSellableProductCannedTest(cannedTestId, sellableProductId, checked)
      .then(() => {
        loadSellableProductCannedTests();
        toast.success("Hand-Scorable updated successfully");
      })
      .catch(() => {
        setLoading(false);
        toast.error("Something went wrong");
      });
  };

  const onDeleteItemBankClick = (itemBankId: number) => {
    setDeleteItemBankId(itemBankId);
    setShowDeleteItemBankModal(true);
  };

  const deleteItemBankRecordHandler = async () => {
    setLoading(true);
    deleteSellableProductItemBank(deleteItemBankId, sellableProductId).then(
      () => {
        setShowDeleteItemBankModal(false);
        loadSellableProductItemBanks();
        if (sellableProductId) {
          getSellableProductById(sellableProductId).then((response) => {
            const ids: number[] = response?.data?.itemBankIds ?? [];
            setSelectedItemBank(
              ids.map((id) => ({ value: String(id), label: "" }))
            );
            setLoading(false);
          });
        } else {
          setLoading(false);
        }
        toast.success("Item bank removed from sellable product");
      }
    );
  };

  const closeDeleteItemBankModal = () => {
    setShowDeleteItemBankModal(false);
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Sellable Product", url: Constant.SELLABLEPRODUCT },
      {
        name: sellableProductId
          ? "Edit Sellable Product"
          : "Add  Sellable Product",
        url: "",
      },
    ];

    if (sellableProductId) {
      items.push({
        name: sellableProductId?.toString(),
        url: "",
      });
    }

    return items;
  };

  const handleReset = () => {
    setSelectState(defaultDropdownValues);
    setSelectSubject([]);
    setSelectGrade(defaultDropdownValues);
    setSelectGradeLevel({ value: "", label: "" });
    setManageNotification(false);
    setCannedTestIds([]);
    setCannedTestInput("");
    setCannedTestError("");
    setSelectedItemBank([]);
  };

  const redirectToList = () => {
    navigate(Constant.SELLABLEPRODUCT);
  };

  const onIsApproveChecked = (e) => {
    setIsApproved(e.target.checked);
  };

  const updateSellableProductSub = async (subjectId, isPrimary) => {
    setLoading(true);
    try {
      await updateSellableProductSubject(
        subjectId,
        sellableProductId,
        isPrimary
      );
      toast.success("Sellable product subject updated successfully");
    } catch (e) {
      toast.error("Something went wrong");
    }
    setLoading(false);
  };

  function handleRedirection(name: string, id: number) {
    if (name === "subject" && id) {
      navigate(Constant.SUBJECTDETAIL.replace(":id", id.toString()), {
        state: { subjectType: 1 },
      });
    } else if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }

  return (
    <AllowedTo
      perform={[
        Permissions.sellable_product_create,
        Permissions.sellable_product_modify,
      ]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}

      {showDeleteCannedTestModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteCannedTestModal}
          deleteRecord={deleteCannedTestRecordHandler}
        />
      )}

      {showDeleteItemBankModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteItemBankModal}
          deleteRecord={deleteItemBankRecordHandler}
        />
      )}

      <div className="flex-1 overflow-auto">
        <div className="h-screen w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {sellableProductId
                  ? "Edit Sellable Product"
                  : "Add Sellable Product"}
              </h3>
            </div>

            <Breadcrumb items={breadcrumbItems()} />

            <div className="flex items-start mt-4 space-x-6">
              <div className={`${"w-1/4"}`}>
                <div className="shadow py-6 border rounded-lg px-4">
                  <div className="text-sm">
                    <div
                      className={`col-span-${sellableProductId ? "4" : "3"}`}
                    >
                      <div className="mb-5">
                        <label
                          htmlFor="sellableProductType"
                          className="block font-medium text-gray-700 whitespace-nowrap mb-1"
                        >
                          Sellable Product Type
                        </label>
                        <Select
                          inputId="sellableProductType"
                          options={productTypes}
                          value={
                            productTypes.find(
                              (t) => t.value === selectedProductType.value
                            ) || null
                          }
                          isDisabled={!!sellableProductId}
                          placeholder="Select type"
                          onChange={(e) => {
                            if (e) setSelectedProductType(e as ISelectElement);
                          }}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                        />
                        {manageNotification && !selectedProductType.value && (
                          <span className="text-red-700 pt-1 text-sm">
                            Sellable Product Type is required
                          </span>
                        )}
                      </div>

                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Sellable Product Name
                      </label>
                      <div
                        className={`cursor-not-allowed ${
                          sellableProductId ? "flex" : ""
                        }`}
                      >
                        <input
                          value={sellableproductName}
                          type="text"
                          onChange={(e: any) => {
                            setsellableproductName(e.target.value);
                          }}
                          className={`${
                            sellableProductId && !isSPNameEdit
                              ? "disabled-input"
                              : ""
                          } mt-1 h-9 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                          required
                        />

                        {sellableProductId && !isSPNameEdit && (
                          <button
                            title="Edit"
                            type="button"
                            onClick={() => setIsSPNameEdit(true)}
                            className="items-center px-1 py-2 ml-1  hover:text-gray-500 text-sm leading-4 font-medium text-gray-700 bg-white"
                          >
                            <EditIcon className="w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                          </button>
                        )}
                        {sellableProductId && isSPNameEdit && (
                          <button
                            title="Update"
                            type="button"
                            onClick={() => {
                              setIsSPNameEdit(false);
                            }}
                            className="items-center px-1 py-2 ml-1  hover:text-gray-500 text-sm leading-4 font-medium text-gray-700 bg-white"
                          >
                            <CheckIcon className="w-6 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                          </button>
                        )}
                        {sellableProductId && isSPNameEdit && (
                          <button
                            title="Cancel"
                            type="button"
                            onClick={() => {
                              setIsSPNameEdit(false);
                              setsellableproductName(editSellableProduct?.name);
                            }}
                            className="items-center px-1 py-2 ml-1 hover:text-gray-500 text-sm leading-4 font-medium text-gray-700 bg-white"
                          >
                            <CancelIcon />
                          </button>
                        )}
                      </div>

                      {sellableproductName === "" &&
                        manageNotification === true && (
                          <span className="text-red-700  pt-1 text-sm">
                            Sellable Product Name is required
                          </span>
                        )}
                    </div>
                  </div>

                  <div className="w-full mt-5">
                    <div>
                      <form>
                        {(parseInt(selectedProductType.value) === 1 ||
                          parseInt(selectedProductType.value) === 2) && (
                          <>
                            <div className="col-span-2">
                              <label className="text-sm text-gray-700">
                                State
                              </label>

                              <Select
                                options={state}
                                defaultValue={selectState || ""}
                                value={selectState}
                                placeholder={""}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    background:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#1A1C23"
                                        : "white",
                                    borderColor:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6B7280"
                                        : "#D1D5DB",
                                    borderWidth: "1px",
                                    "&:hover": {
                                      borderColor:
                                        state.isFocused &&
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6b7280"
                                          : state.isFocused
                                          ? "#4c5563"
                                          : "",
                                    },
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "#374051",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "",
                                  }),
                                }}
                                onChange={(e) => {
                                  updateMultiDropdownValues(e, "state");
                                }}
                              ></Select>
                            </div>
                            <div className="col-span-2 mt-5">
                              <label className="text-sm text-gray-700">
                                Grade
                              </label>

                              <Select
                                options={grade}
                                defaultValue={selectGrade || ""}
                                value={selectGrade}
                                placeholder={""}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                                onChange={(e) => {
                                  updateMultiDropdownValues(e, "grade");
                                }}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    background:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#1A1C23"
                                        : "white",
                                    borderColor:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6B7280"
                                        : "#D1D5DB",
                                    borderWidth: "1px",
                                    "&:hover": {
                                      borderColor:
                                        state.isFocused &&
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6b7280"
                                          : state.isFocused
                                          ? "#4c5563"
                                          : "",
                                    },
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "#374051",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "",
                                  }),
                                }}
                              ></Select>
                            </div>

                            <div
                              className={`col-span-2 mt-5 ${
                                selectedSubjectType.value == "2" ? "hidden" : ""
                              }`}
                            >
                              <label className="text-sm text-gray-700">
                                Grade Level
                              </label>

                              <Select
                                options={gradeLevelData}
                                defaultValue={selectGradeLevel || ""}
                                value={selectGradeLevel}
                                placeholder={""}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                                onChange={(e) => {
                                  updateMultiDropdownValues(e, "gradeLevel");
                                }}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    background:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#1A1C23"
                                        : "white",
                                    borderColor:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6B7280"
                                        : "#D1D5DB",
                                    borderWidth: "1px",
                                    "&:hover": {
                                      borderColor:
                                        state.isFocused &&
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6b7280"
                                          : state.isFocused
                                          ? "#4c5563"
                                          : "",
                                    },
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "#374051",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "",
                                  }),
                                }}
                              ></Select>
                            </div>
                            <div className="col-span-2 mt-5">
                              <label className="text-sm text-gray-700">
                                Subject Type
                              </label>

                              <Select
                                options={subjectTypes}
                                defaultValue={selectedSubjectType || ""}
                                value={selectedSubjectType}
                                placeholder={""}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                                onChange={(e) => {
                                  updateMultiDropdownValues(e, "subjectType");
                                }}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    background:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#1A1C23"
                                        : "white",
                                    borderColor:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6B7280"
                                        : "#D1D5DB",
                                    borderWidth: "1px",
                                    "&:hover": {
                                      borderColor:
                                        state.isFocused &&
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6b7280"
                                          : state.isFocused
                                          ? "#4c5563"
                                          : "",
                                    },
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "#374051",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "",
                                  }),
                                }}
                              ></Select>
                            </div>

                            <div className="grid grid-cols-1 mt-5">
                              <label className="font-medium text-gray-700 whitespace-nowrap">
                                Subject
                              </label>

                              <div
                                id="contentAreaFilter"
                                className="mt-1 block w-full focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                              >
                                <MultiSelect
                                  options={subjects}
                                  selectedItems={selectSubject}
                                  setSelectedItems={setSelectSubject}
                                />

                                {(!selectSubject ||
                                  selectSubject?.length === 0) &&
                                  !sellableProductId &&
                                  manageNotification === true && (
                                    <span className="text-red-700 inline-block pt-1 text-sm">
                                      Subject is required
                                    </span>
                                  )}
                              </div>
                            </div>
                          </>
                        )}

                        {parseInt(selectedProductType.value) === 3 && (
                          <div className="col-span-2 mt-5">
                            <label
                              htmlFor="cannedTestId"
                              className="text-sm text-gray-700 font-medium"
                            >
                              Canned Test ID
                            </label>
                            <input
                              id="cannedTestId"
                              type="text"
                              value={cannedTestInput}
                              onChange={handleCannedTestChange}
                              className="mt-1 h-9 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              placeholder="Enter Canned Test IDs (comma-separated)"
                            />
                            {cannedTestError && (
                              <span className="text-red-700 pt-1 text-sm">
                                {cannedTestError}
                              </span>
                            )}
                            {manageNotification &&
                              cannedTestIds.length === 0 &&
                              !cannedTestError && (
                                <span className="text-red-700 pt-1 text-sm">
                                  Canned Test ID is required
                                </span>
                              )}
                          </div>
                        )}

                        {parseInt(selectedProductType.value) === 4 && (
                          <div className="col-span-2 mt-5">
                            <label
                              htmlFor="itemBankSelect"
                              className="text-sm text-gray-700 font-medium"
                            >
                              Item Bank Selection
                            </label>
                            <Select
                              isMulti
                              inputId="itemBankSelect"
                              options={itemBanks}
                              value={itemBanks.filter((b) =>
                                selectedItemBank.some(
                                  (s) => s.value === b.value
                                )
                              )}
                              placeholder="Select Item Bank(s)"
                              onChange={(e) =>
                                setSelectedItemBank(e as ISelectElement[])
                              }
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                            />
                            {manageNotification &&
                              selectedItemBank.length === 0 && (
                                <span className="text-red-700 pt-1 text-sm">
                                  Item Bank is required
                                </span>
                              )}
                          </div>
                        )}

                        <div className="flex mt-5">
                          <input
                            id="isApproved"
                            name="isApproved"
                            type="checkbox"
                            checked={isApproved}
                            defaultChecked={
                              editSellableProduct?.isApproved ?? true
                            }
                            className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                            onChange={(e) => onIsApproveChecked(e)}
                          />
                          <label
                            htmlFor="isApproved"
                            className="ml-1.5 text-sm text-gray-700"
                          >
                            Approved
                          </label>
                        </div>

                        <div className="flex mt-5">
                          <input
                            id="isActive"
                            name="isActive"
                            type="checkbox"
                            checked={isActive}
                            defaultChecked={
                              editSellableProduct?.isActive ?? true
                            }
                            className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                            onChange={(e) => setIsActive(e.target.checked)}
                          />
                          <label
                            htmlFor="isActive"
                            className="ml-1.5 text-sm text-gray-700"
                          >
                            Active
                          </label>
                        </div>
                        <div className="flex justify-end mt-8 items-center border-t ">
                          {!sellableProductId && (
                            <button
                              type="button"
                              className="inline-flex items-center px-3 py-2 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                              onClick={() => onUpdateClick("add")}
                            >
                              Save
                            </button>
                          )}
                          {sellableProductId && (
                            <button
                              type="button"
                              className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                              onClick={() => onUpdateClick("update")}
                            >
                              Update
                            </button>
                          )}
                          &nbsp; &nbsp;
                          <Link to={Constant.SELLABLEPRODUCT} className="ml-2">
                            <button
                              type="button"
                              onClick={() => {
                                sellableProductId
                                  ? handleReset()
                                  : redirectToList();
                              }}
                              className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                            >
                              Cancel
                            </button>
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              {sellableProductId && (
                <div className="w-3/4 rounded-lg overflow-hidden">
                  {(parseInt(selectedProductType.value) === 1 ||
                    parseInt(selectedProductType.value) === 2) && (
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-primary-color">
                        <tr>
                          <th
                            scope="col"
                            className="inline-flex items-center gap-2 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            <span className="flex gap-2">Id</span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2  font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            <span className="flex gap-2">Subject</span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2  font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            <span className="flex gap-2">Content Area</span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                          >
                            <span className="flex gap-2 justify-center">
                              Primary
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sellableproductSubjects.map((product, index) => (
                          <tr
                            key={index}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-100"
                            }
                          >
                            <td
                              className="px-3 py-2  whitespace-nowrap text-sm text-left font-normal text-gray-500 cursor-pointer text-indigo-600 hover:text-indigo-500"
                              onClick={() =>
                                handleRedirection(
                                  "subject",
                                  parseInt(product?.value)
                                )
                              }
                            >
                              <a
                                href={Constant.SUBJECTDETAIL.replace(
                                  ":id",
                                  product.value.toString()
                                )}
                              >
                                {product.value}
                              </a>
                            </td>
                            <td
                              className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 cursor-pointer text-indigo-600 hover:text-indigo-500"
                              onClick={() =>
                                handleRedirection(
                                  "subject",
                                  parseInt(product?.value)
                                )
                              }
                            >
                              <a
                                href={Constant.SUBJECTDETAIL.replace(
                                  ":id",
                                  product.value.toString()
                                )}
                              >
                                {product.name}
                              </a>
                            </td>
                            <td
                              className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 cursor-pointer text-indigo-600 hover:text-indigo-500"
                              onClick={() =>
                                handleRedirection(
                                  "content",
                                  parseInt(product?.contentAreaId)
                                )
                              }
                            >
                              <a
                                href={Constant.EDITCONTENT.replace(
                                  ":id",
                                  product?.contentAreaId.toString()
                                )}
                              >
                                {product.contentAreaName}
                              </a>
                            </td>
                            <td className="text-center px-3 py-2 pl-6 whitespace-nowrap text-sm font-normal text-gray-500">
                              <input
                                type="checkbox"
                                defaultChecked={product.isPrimary}
                                className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                onChange={(e) =>
                                  updateSellableProductSub(
                                    product.value,
                                    e.target.checked
                                  )
                                }
                              />
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                              <div className="flex gap-3 justify-center">
                                <DeleteIcon
                                  onClick={(e) => onDeleteClick(product.value)}
                                  className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                  {parseInt(selectedProductType.value) === 3 && (
                    <SellableProductAssociationTable
                      items={sellableProductCannedTests.map((ct) => ({
                        id: ct.cannedTestId,
                        name: ct.name,
                        isHandScorable: ct.isHandScorable,
                      }))}
                      idLabel="Canned Test ID"
                      nameLabel="Canned Test Name"
                      onDelete={onDeleteCannedTestClick}
                      onRowClick={(id) => handleRedirection("canned-tests", id)}
                      getEditPath={(id) =>
                        Constant.CANNEDTESTDETAIL.replace(
                          ":cannedtestId",
                          id.toString()
                        )
                      }
                      showHandScorable
                      onToggleHandScorable={onToggleHandScorable}
                    />
                  )}

                  {parseInt(selectedProductType.value) === 4 && (
                    <SellableProductAssociationTable
                      items={sellableProductItemBanks.map((ib) => ({
                        id: ib.itemBankId,
                        name: ib.name,
                      }))}
                      idLabel="Premium Item Bank ID"
                      nameLabel="Premium Item Bank Name"
                      onDelete={onDeleteItemBankClick}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(ManageSellableProducts);
